import {useProductService} from '@/composables/product_service'
import {getMappedProduct} from '~/assets/js/utils/product_attributes_mapping'
import {useUserStore} from '@/store/user'
import {PROPERTY_SCOPE_NAMES} from '~/assets/js/constants'
import useI18nExtended from './usei18nExtended'

export const useReloadProduct = (productRef) => {
  const reloadProductsInProgress = ref(false)
  const productService = useProductService()
  const userStore = useUserStore()
  const {locale} = useI18nExtended()
  const app = useNuxtApp()

  async function reloadProduct(plantCode) {
    reloadProductsInProgress.value = true
    if (!productRef.value) {
      reloadProductsInProgress.value = false
      return
    }
    try {
      const updatedProduct = await productService.getProductBySkuNew(
        productRef.value.sku,
        app.$globalization.getRegion(),
        locale.value,
        userStore.showInchValues,
        plantCode,
        PROPERTY_SCOPE_NAMES.PRODUCT_PAGE
      )
      if (updatedProduct) {
        productRef.value = getMappedProduct(updatedProduct)
      }
    } finally {
      reloadProductsInProgress.value = false
    }
  }

  return {
    reloadProductsInProgress,
    reloadProduct
  }
}
